




























import { Component, Vue, Mixins } from "vue-property-decorator";
import BaseFormMixin from "./BaseFormMixin";
import ModalComponent from "@/components/layout/ModalComponent.vue";
import api from "@/lib/Api";

@Component({
  mixins: [BaseFormMixin],
  components: { ModalComponent }
})
export default class GroupModalComponent extends Mixins(BaseFormMixin) {
  basisUsers: Array<{Id:number, UserName:string}> = [];
  created() {
    api.get("/manage/group/listBasisUsers").then(res => {
       this.basisUsers = res.data.data;
    });
  }
}
